export default __webpack_public_path__ + "static/media/tm-portal-dark.d73fae60.png";